module.exports = __webpack_public_path__ + "01448982f75c4ea38d7e10a788ad56f2.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_2-320.webp
// module id = 290
// module chunks = 0